module.exports = __webpack_public_path__ + "static/media/ProximaNova-Light.d7782185.eot";